import Purchases from '@/views/Purchases/Index.vue'

export default [
    {
        path: '/purchases',
        name: 'purchases',
        component: Purchases,
        redirect: { name: 'purchasesMaterialReservations' },
        meta: {
            title: 'purchases.root.pageTitle',
            menuRendered: true,
            menuTitle: 'purchases.root.menuTitle',
            icon: 'mdi-shopping-outline'
        },
        children: [
            {
                path: '/purchases/material-reservations',
                name: 'purchasesMaterialReservations',
                component: () => import('@/views/Purchases/MaterialReservations/Index.vue'),
                meta: {
                    title: 'purchases.materialReservations.pageTitle',
                    menuRendered: true,
                    menuTitle: 'purchases.materialReservations.menuTitle',
                    requiresAuth: true,
                    permission: 'material_reservations'
                }
            }
        ]
    }
]
